export default __webpack_public_path__ + "static/media/craon35.5a76ebe3.jpg";